module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAYAAADzoH0MAAABDUlEQVQ4T6XUPwrCMBQG8C+1HTyCLrZ6gChOjo6OCqUOnTtaryJ4AEEH3b2AJxAXB0EUBM8gWhpJ0Vrtv6RmzvdLyHt5BH8u8smbJYNWZwqwPu4mK1H3BZglnVYWBBgC8BQQWxQJAIO6c4DZkVOFkQDQqWsRsAUAVRYJ36AoEnlEoEFdy5e8yRfAry+LxABZJBGQQVIBUSQTEEFyAbQdzXiUNyCsE21vBuzP6q2ZDbQdre6Vlwxs8PM3Dp7idy/b6TUdEAhzNBkQDCcDEuE4IBn+BgqEP0DBcAgY1F0CzEorVdZ4C6pQo6O+AvA5qL02h3XOm41hGSPI6d0keeFYFRqtce8Ob8c7TCTM9zwBZ4/EtzU4IUcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back_right2.png
// module id = Uwd2
// module chunks = 167